import React from 'react';
import { API } from '@gin-betting/core';

import { OrganizationIcon } from 'components';
import { groupCategorizerItemsByOrganizations } from '../../../../utils';
import CategorizerSubRow from '../../CategorizerSubRow';

interface Props {
    items: API.CategorizerItem[];
    topCategorizerItem: API.CategorizerItem;
    sportId: string;
    selectedTournamentIds: string[];
    isAllItemsInSportChecked: boolean;
    onTournamentIdsChange: (nextTournamentIds: string[]) => void;
}

const OrganizationRow: React.FC<Props> = ({
    items,
    topCategorizerItem,
    sportId,
    selectedTournamentIds,
    isAllItemsInSportChecked,
    onTournamentIdsChange: handleTournamentIdsChange,
}) => {
    const groupedItemsByOrganization = groupCategorizerItemsByOrganizations(
        items,
        sportId
    );

    return (
        <React.Fragment>
            {groupedItemsByOrganization.map(organization => (
                <CategorizerSubRow
                    key={organization.name}
                    label={organization.name}
                    topCategorizerItem={topCategorizerItem}
                    items={organization.items}
                    selectedTournamentIds={selectedTournamentIds}
                    isAllItemsInSportChecked={isAllItemsInSportChecked}
                    onTournamentIdsChange={handleTournamentIdsChange}
                    isGroupWithOneItem={groupedItemsByOrganization.length === 1}
                    additionalIcon={
                        <OrganizationIcon logo={organization.logo} />
                    }
                />
            ))}
        </React.Fragment>
    );
};

export default OrganizationRow;
